// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEpmMasterFunctionalitiesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListEpmMasterFunctionalitiesQuery = { __typename?: 'Query' } & {
  listEpmMasterFunctionalities: { __typename?: 'ListEpmMasterFunctionalities' } & Pick<
    Types.ListEpmMasterFunctionalities,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'EpmMasterFunctionality' } & Pick<
          Types.EpmMasterFunctionality,
          'id' | 'name' | 'enabled' | 'sortOrder' | 'createdAt' | 'updatedAt'
        > & {
            usageStats: { __typename?: 'EpmMasterSimpleUsageStats' } & Pick<
              Types.EpmMasterSimpleUsageStats,
              'employeeAllocationCount'
            >;
          }
      >;
    };
};

export const ListEpmMasterFunctionalitiesDocument = /*#__PURE__*/ gql`
    query listEpmMasterFunctionalities($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String) {
  listEpmMasterFunctionalities(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword}
  ) {
    items {
      id
      name
      enabled
      sortOrder
      createdAt
      updatedAt
      usageStats {
        employeeAllocationCount
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListEpmMasterFunctionalitiesQuery__
 *
 * To run a query within a React component, call `useListEpmMasterFunctionalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEpmMasterFunctionalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEpmMasterFunctionalitiesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListEpmMasterFunctionalitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>(
    ListEpmMasterFunctionalitiesDocument,
    options,
  );
}
export function useListEpmMasterFunctionalitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEpmMasterFunctionalitiesQuery,
    ListEpmMasterFunctionalitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>(
    ListEpmMasterFunctionalitiesDocument,
    options,
  );
}
// @ts-expect-error
export function useListEpmMasterFunctionalitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEpmMasterFunctionalitiesQuery,
    ListEpmMasterFunctionalitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>;
export function useListEpmMasterFunctionalitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListEpmMasterFunctionalitiesQuery | undefined,
  ListEpmMasterFunctionalitiesQueryVariables
>;
export function useListEpmMasterFunctionalitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEpmMasterFunctionalitiesQuery, ListEpmMasterFunctionalitiesQueryVariables>(
    ListEpmMasterFunctionalitiesDocument,
    options,
  );
}
export type ListEpmMasterFunctionalitiesQueryHookResult = ReturnType<typeof useListEpmMasterFunctionalitiesQuery>;
export type ListEpmMasterFunctionalitiesLazyQueryHookResult = ReturnType<
  typeof useListEpmMasterFunctionalitiesLazyQuery
>;
export type ListEpmMasterFunctionalitiesSuspenseQueryHookResult = ReturnType<
  typeof useListEpmMasterFunctionalitiesSuspenseQuery
>;
